import modals from "../helpers/modals";

export default {
    bind(el, binding, vnode) {
        let $parts = binding.expression.split('.');
        let $name = $parts[$parts.length - 1];

        el.dataset.roll = $name;

        vnode.context.$watch(
            () => {
                return vnode.context.modals[$name];
            },
            ($_new) => {
                if ( $_new ) {
                    el.classList.remove("v-hide");
                } else {
                    el.classList.add("v-hide");
                }
            }
        );

      //  el.style.display = 'none';
        if (!('ontouchstart' in document.documentElement)) {
            el.addEventListener('mouseenter', () => {
                // console.log("Roll Enter");
                // console.log(modals.display);
             //   if ( modals.hover ) {
                    modals.enter($name, () => {
                        vnode.context.$nextTick(function () {
                            vnode.context.modals = modals.items;
                            el.classList.remove("v-hide");
                        });
                    });
             //   }
            }, { passive: true });

            el.addEventListener('mouseleave', () => {
               // console.log("Roll leave");
                if ( modals.hover ) {
                    modals.leave(() => {
                        vnode.context.$nextTick(function () {
                            vnode.context.modals = modals.items;
                            el.classList.add("v-hide");
                        });
                    });
                }
            }, { passive: true });


        }
    }
}